import { useContext, useState, useCallback } from 'react';
import { EERIE } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Popover } from 'foundations-components/transitional/components/Popover';
import UsageTrackerContext from 'automation-ui-usage-tracking/UsageTrackerContext';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { trackEvent } from 'automation-ui-usage-tracking/trackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const POPOVER_WIDTH = '350px';
function ActionDetailsButton({
  use = 'link',
  Content,
  trackingIdentifier,
  'data-test-id': dataTestId
}) {
  const {
    usageTracker
  } = useContext(UsageTrackerContext);
  const [open, setOpen] = useState(false);
  const trackPopoverInteraction = useCallback(isOpen => {
    trackEvent(usageTracker, Trackables.CLICKED_ACTION_DETAILS_BUTTON, {
      actionType: trackingIdentifier,
      interaction: isOpen ? 'opened popover' : 'closed popover'
    });
  }, [usageTracker, trackingIdentifier]);
  const handleClick = useCallback(event => {
    event.stopPropagation();
    setOpen(isOpen => {
      trackPopoverInteraction(!isOpen);
      return !isOpen;
    });
  }, [setOpen, trackPopoverInteraction]);
  const handleOpenChange = useCallback(({
    target: {
      value: isOpen
    }
  }) => {
    trackPopoverInteraction(isOpen);
    setOpen(isOpen);
  }, [setOpen, trackPopoverInteraction]);
  return /*#__PURE__*/_jsx(Popover, {
    open: open,
    placement: "right bottom",
    inlineSize: POPOVER_WIDTH,
    Content: Content,
    closeOnOutsideClick: true,
    onOpenChange: handleOpenChange,
    children: use === 'icon' ? /*#__PURE__*/_jsx(UIIconButton, {
      use: "unstyled",
      onClick: handleClick,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-details.popover-toggle-button.details.show"
      }),
      placement: "bottom",
      "data-test-id": dataTestId,
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "view",
        color: EERIE
      })
    }) : /*#__PURE__*/_jsx(UIButton, {
      use: "link",
      onClick: handleClick,
      "data-test-id": dataTestId,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-details.popover-toggle-button.details.show"
      })
    })
  });
}
export default ActionDetailsButton;